/**
 * Whether a modal is open over the element (e.g. a floating comment): it then
 * handles Esc itself. The modal the element is in (e.g. the versions
 * comparison) does not count. Closed modals may stay in the DOM.
 */
export function isModalOpenOver(element: Element | null): boolean {
  return Array.from(
    document.querySelectorAll<HTMLElement>('.ant-modal-wrap')
  ).some((modal) => modal.style.display !== 'none' && !modal.contains(element));
}
